module.exports = __webpack_public_path__ + "static/media/instructor-onboarding-image16.9524a341.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/instructor-onboarding-image16.png
// module id = 2637
// module chunks = 0